<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'#9d174d'"></ngx-loading-bar>
<!-- / -->

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <section class="pt-8 sm:pt-0 z-10 relative">
      <ng-container *ngIf="banners?.length > 0">
        <carousel class="carousel-html-content" [objectFit]="'cover'" [pauseOnFocus]="true" [cellWidth]="'100%'" [height]="350" [autoplay]="true" [dots]="true" [loop]="true">
          <ng-container *ngFor="let banner of banners;">
            <ng-container *ngIf="banner.core_visual_banner_area == 'full_banner_home'">
              <div class="carousel-cell">
                <img loading="lazy" class="hidden sm:block cursor-pointer" src="{{banner.url_image}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
                <img loading="lazy" class="sm:hidden rounded-lg" src="{{banner.url_image_mobile}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
              </div>
            </ng-container>
          </ng-container>
        </carousel>
      </ng-container>
    </section>

    <ng-container *ngIf="products0st?.total > 0">
      <section class="py-8">
        <p class="text-pink-800 font-bold text-lg sm:text-3xl">Produtos que interessam a você</p>
        <ng-container *ngIf="cart?.client_marketplace_cart_uid">
          <div class="py-4">
            <div class="w-full overflow-x-auto no-scrollbar">
              <div class="inline-flex space-x-6 sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-x-6 md:gap-x-6 lg:gap-x-6 sm:gap-y-6 sm:space-x-0">
                <ng-container *ngFor="let product of products0st?.data;">
                  <IncludeProductContainer [cart]="cart" [product]="product.product"></IncludeProductContainer>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </ng-container>

    <!-- carrossel 1 -->
    <div class="py-4">
      <div class="w-full overflow-x-auto no-scrollbar">
        <div class="inline-flex space-x-8 sm:grid sm:grid-cols-3 sm:gap-x-4 sm:space-x-0">
          <a [routerLink]="['/p/super-kit-lave-sem-medo-cinco-embalagens-com-vinte-unidades-cad/id/81599300']"
            ><img loading="lazy" class="rounded-lg w-full hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2024/01/s1400x-1706019424-bannerinferior-0506-casadege-v1-1.png" alt="Super Kit Lave Sem Medo"
          /></a>
          <a [routerLink]="['/p/kit-sem-passar-tres-unidades/id/81599259']"> <img loading="lazy" class="rounded-lg w-full hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2024/01/s1400x-1706019434-bannerinferior02-0506-casadege-v1-1.png" alt="Kit Sem Passar Baby Soft" /></a>
          <a [routerLink]="['/p/kit-desinfetante-lavanda/id/108286219']"> <img loading="lazy" class="rounded-lg w-full hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2024/01/s1400x-1706019444-bannerinferior03-0506-casadege-v1-2.png" alt="Kit Desinfetante Lavanda" /></a>
        </div>
      </div>
    </div>

    <section class="py-8">
      <p class="text-pink-800 font-bold text-lg sm:text-3xl">Os queridinhos da Casa de Gê</p>
      <ng-container *ngIf="messageProcess == true">
        <div class="py-4 inline-flex space-x-8 sm:grid sm:grid-cols-4 sm:gap-x-4 sm:gap-y-6 sm:space-x-0">
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
        </div>
      </ng-container>
      <ng-container *ngIf="products1st?.total > 0">
        <ng-container *ngIf="cart?.client_marketplace_cart_uid">
          <div class="py-4">
            <div class="w-full overflow-x-auto no-scrollbar">
              <div class="inline-flex space-x-6 sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-x-6 md:gap-x-6 lg:gap-x-6 sm:gap-y-6 sm:space-x-0">
                <ng-container *ngFor="let product of products1st?.data.hits;">
                  <IncludeProductContainer [cart]="cart" [product]="product"></IncludeProductContainer>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </section>

    <section class="py-4">
      <p class="text-pink-800 font-bold text-lg sm:text-3xl">Veja nosso top 10 mais vendidos</p>
      <ng-container *ngIf="messageProcess == true">
        <div class="py-4 inline-flex space-x-8 sm:grid sm:grid-cols-4 sm:gap-x-6 sm:gap-y-6 sm:space-x-0">
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
        </div>
      </ng-container>
      <ng-container *ngIf="products2n?.total > 0">
        <ng-container *ngIf="cart?.client_marketplace_cart_uid">
          <div class="py-4">
            <div class="w-full overflow-x-auto no-scrollbar">
              <div class="inline-flex space-x-6 sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-x-6 md:gap-x-6 lg:gap-x-6 sm:gap-y-6 sm:space-x-0">
                <ng-container *ngFor="let product of products2n?.data.hits;">
                  <IncludeProductContainer [cart]="cart" [product]="product"></IncludeProductContainer>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </section>

    <section class="z-10 relative">
      <ng-container *ngIf="banners?.length > 0">
        <carousel class="carousel-html-content z-10 relative" [objectFit]="'cover'" [pauseOnFocus]="true" [cellWidth]="'100%'" [height]="350" [autoplay]="true" [dots]="true" [loop]="true">
          <ng-container *ngFor="let banner of banners;">
            <ng-container *ngIf="banner.core_visual_banner_area == 'middle_banner_home'">
              <div class="carousel-cell">
                <img loading="lazy" class="hidden sm:block cursor-pointer" src="{{banner.url_image}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
                <img loading="lazy" class="sm:hidden rounded-lg" src="{{banner.url_image_mobile}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
              </div>
            </ng-container>
          </ng-container>
        </carousel>
      </ng-container>
    </section>

    <section class="hidden sm:block pt-8">
      <div class="frame_video">
        <iframe loading="lazy" title="Casa de Gê - Sem Passar" class="w-[640px] h-[360px]" src="https://www.youtube.com/embed/LhIqZQz9zPU" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </section>

    <section class="py-8">
      <p class="text-pink-800 font-bold text-lg sm:text-3xl">Veja nossos Lançamentos</p>
      <ng-container *ngIf="products3th?.total == undefined">
        <div class="py-4 inline-flex space-x-8 sm:grid sm:grid-cols-4 sm:gap-x-4 sm:gap-y-6 sm:space-x-0">
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
          <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
        </div>
      </ng-container>
      <ng-container *ngIf="products3th?.total > 0">
        <ng-container *ngIf="cart?.client_marketplace_cart_uid">
          <div class="py-4 sm:mx-auto">
            <div class="w-full overflow-x-auto no-scrollbar">
              <div class="inline-flex space-x-8 sm:grid sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-x-6 md:gap-x-6 lg:gap-x-6 sm:gap-y-6 sm:space-x-0">
                <ng-container *ngFor="let product of products3th?.data.hits;">
                  <IncludeProductContainer [cart]="cart" [product]="product"></IncludeProductContainer>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </section>

    <section class="z-10 relative">
      <ng-container *ngIf="banners?.length > 0">
        <carousel class="carousel-html-content z-10 relative" [objectFit]="'cover'" [pauseOnFocus]="true" [cellWidth]="'100%'" [height]="350" [autoplay]="true" [dots]="true" [loop]="true">
          <ng-container *ngFor="let banner of banners;">
            <ng-container *ngIf="banner.core_visual_banner_area == 'bottom_banner_home'">
              <div class="carousel-cell">
                <img loading="lazy" class="hidden sm:block cursor-pointer" src="{{banner.url_image}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
                <img loading="lazy" class="sm:hidden rounded-lg" src="{{banner.url_image_mobile}}" alt="{{banner.name}}" (click)="banners_fnc_cta(banner)" />
              </div>
            </ng-container>
          </ng-container>
        </carousel>
      </ng-container>
    </section>

    <!-- marcas -->
    <section class="py-8">
      <p class="text-pink-800 font-bold text-lg sm:text-3xl">Confira as marcas campeãs de vendas na Casa de Gê.</p>
      <div class="py-4 w-full overflow-x-auto no-scrollbar">
        <div class="inline-flex space-x-8 sm:grid sm:grid-cols-4 sm:gap-x-4 sm:space-x-0">
          <a [routerLink]="['/s/salesman/Amazon H2O']"> <img loading="lazy" class="rounded-md hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2023/06/s1400x-1687805907-banner-0506-amazonh2o-v1-1.png" alt="Amazon H2O" /></a>
          <a [routerLink]="['/s/salesman/Baby Soft']"> <img loading="lazy" class="rounded-md hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2023/06/s1400x-1687805899-banner-0506-babysoft-v1-1.png" alt="Baby Soft" /></a>
          <a [routerLink]="['/s/salesman/Hiper Clean']"> <img loading="lazy" class="rounded-md hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2023/06/s1400x-1687805888-banner-0506-hiperclean-v1-1.png" alt="Hiper Clean" /></a>
          <a [routerLink]="['/s/salesman/Urca']"> <img loading="lazy" class="rounded-md hover:opacity-50 cursor-pointer" src="https://d37a3z0otx9qd3.cloudfront.net/casadege.com.br/upload/image/1/2023/06/s1400x-1687805877-banner-0506-urca-v1-1.png" alt="Urca" /></a>
        </div>
      </div>
    </section>

    <!-- instagram -->
    <!-- <ng-container *ngIf="instagram?.length > 0">
    <div class="-mx-4 mt-4 mb-8 w-100 sm:mb-0 sm:mx-0 sm:w-full bg-amber-100 p-16 no-scrollbar">
      <div class="flex flex-col sm:items-center justify-center space-y-6">
        <a href="https://instagram.com/casadege" target="_blank" class="flex items-center space-x-2 text-center justify-center">
          <i class="pi pi-instagram" style="font-size: 2rem; color: #8c2948"></i>
          <p class="text-pink-800 text-xxl font-bold">@casadege</p>
        </a>

        <div class="flex overflow-auto justify-start space-x-4 mt-2 sm:overflow-hidden sm:justify-start sm:space-x-4 sm:mt-6">
          <ng-container *ngFor="let insta of instagram">
            <img width="300" src="{{insta.thumbnails[4].src}}" alt="Instagram" />
            <a href="https://instagram.com/casadege" target="_blank">
              <div crossorigin="anonymous" class="bg-cover bg-no-repeat bg-center h-56 w-56 rounded-lg sm:w-[360px] sm:h-[360px] hover:opacity-50" style="background-image: url({{insta.media_url}})"></div>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container> -->
  </div>
</main>
